<template>
  <div>
    <b-modal
      id="add-external-user"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('SubmitNewUser')"
      size="lg"
      hide-footer
      @close="onCancel"
    >
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
        <b-form-group
          id="input-group-6"
          label-for="input-6"
          :label="`${$t('EmployeeFirstName')}`"
        >
          <b-form-input
            id="input-12"
            v-model="firstName"
            aria-describedby="input-1-live-feedback"
          />
          <p
            v-if="!firstName && buttonSubmited"
            style="color:red;"
          >
            {{ $t('This_is_a_required_field') }}
          </p>
        </b-form-group>
        <b-form-group
          id="input-group-6"
          label-for="input-6"
          :label="`${$t('EmployeeLastName')}`"
        >
          <b-form-input
            id="input-12"
            v-model="lastName"
            aria-describedby="input-1-live-feedback"
          />
          <p
            v-if="!lastName && buttonSubmited"
            style="color:red;"
          >
            {{ $t('This_is_a_required_field') }}
          </p>
        </b-form-group>
        <b-form-group
          :label="$t('Filiale')"
          style="width:100%;"
        >
          <vue-select
            id="input-5"
            v-model="store"
            required
            :options="getFiliales"
            label="storeName"
            :reduce="(e) => e.storeId"
            :clearable="false"
            :placeholder="$t('Select')"
          />
          <p
            v-if="!store && buttonSubmited"
            style="color:red;"
          >{{ $t('This_is_a_required_field') }}
          </p>
        </b-form-group>
        <b-form-group
          id="input-group-6"
          :label="`${$t('EmployeePhoneN')}:`"
          label-for="input-9"
        >
          <vue-phone-number-input
            id="input-6"
            v-model="phoneNumber"
            default-country-code="CH"
            :error="
              isPhoneNumberValid == null ? false : isPhoneNumberValid == false ? true : false
            "
            :preferred-countries="['AL', 'XK', 'DE']"
            @update="getFormattedNumber"
          />
          <p
            v-if="!phoneNumber && buttonSubmited"
            style="color:red;"
          >
            {{ $t('This_is_a_required_field') }}
          </p>
        </b-form-group>
      </div>
      <b-form>
        <b-form
          class="form2"
          style="margin-top:10px"
        >
          <b-button
            type="button"
            class="buttonSubmit"
            style="margin-right: 0px"
            @click="onSubmit"
          >
            {{ $t("VacationSubmit") }}
          </b-button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 0px"
            @click="onCancel"
          >
            {{ $t("VacationCancel") }}
          </b-button>
        </b-form>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
  },
  data() {
    return {
      countryCode: '',
      phoneNumber: '',
      isPhoneNumberValid: false,
      firstName: null,
      lastName: null,
      store: null,
      buttonSubmited: false,
    };
  },
  computed: {
    ...mapGetters([
      'getFiliales',
    ]),
  },
  watch: {
  },
  mounted() {
    this.loadFilialePagination({
      status: true,
      storeName: null,
      pageNumber: 1,
      pageSize: 50,
    })
  },
  methods: {
    ...mapActions(['loadFilialePagination']),
    getFormattedNumber(n) {
      if (n.isValid == true) {
        this.isPhoneNumberValid = true;
        this.phoneNumber = n.nationalNumber;
        this.countryCode = n.countryCallingCode;
      } else {
        this.countryCode = '';
        this.isPhoneNumberValid = false;
      }
    },
    onSubmit() {
      this.buttonSubmited = true;
      if ((!this.firstName || !this.store || !this.phoneNumber || !this.lastName) && this.buttonSubmited) {
        return;
      }
      const object = {
        firstName: this.firstName,
        lastName: this.lastName,
        countryCode: this.countryCode,
        phoneNumber: this.phoneNumber,
        storeId: this.store,
      }
      this.$emit('addExternalEmployee', object);
      this.onReset();
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.$refs.modal.hide();
      this.countryCode = ''
      this.phoneNumber = ''
      this.isPhoneNumberValid = false
      this.firstName = null
      this.lastName = null
      this.store = null
      this.buttonSubmited = false;
    },
  },
};
</script>

  <style lang="scss" scoped>
  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    align-items: flex-end;
  }
  .form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .form2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 50%
  }
  .flex-form {
    display: flex;
    flex-direction: column;
  }
  .uploadButtons {
    display: flex;
    align-items: flex-end;
  }
  .country-phone-input .dropdown:focus {
    outline: none;
    color: grey;
  }
  </style>
